export default factor => `${5 * factor}px`;
